var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._b({class:_vm.activeLogoCheck,attrs:{"loading":"lazy","src":_vm.customerIcon,"id":"customerlogoID","alt":"Logo"}},'img',_vm.lazyImageProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }